<ng-container *ngIf="customDefaultPlaceCategory">
    <div *ngIf="menuMode==='topbar'&&!customDefaultPlaceCategory.useDefault">
        <ig-nested-menus #customDefaultPlaceBtn [items]="customDefaultPlaceCategory.customCategories"
                         [useNonLeafMenuClick]="useNonLeafMenuClick"
                         (onClick)="selectCustomDefaultPlaceCategory($event)"
                         (onNonLeafClick)="nonLeafClick($event)"></ig-nested-menus>
    </div>

    <ig-accordion #accordion *ngIf="menuMode==='sidebar'||(menuMode==='topbar'&&customDefaultPlaceCategory.useDefault)"
                  (onClearFilter)="filterPlace('All')" [title]="title" id="place-filter-category"
                  class="sidebar-place-category top-bar-font-size"
                  [class.default-category]="customDefaultPlaceCategory.useDefault">

        <div (click)="filterPlace('All')" role="button" tabindex="0" class="all-category"
             [class.is-selected]="isSelected('All')">
            All Places
        </div>

        <ng-container *ngIf="customDefaultPlaceCategory.useDefault">
            <ng-container *ngIf="!loadingToggles&&toggleAndSource?.dataSource?.businessType==='normal'">
                <div item *ngIf="toggleAndSource.toggle.placeCategory.accommodation"
                     (click)="filterPlace('Accommodations')" role="button"
                     [class.is-selected]="isSelected('Accommodations')">
                    Accommodations
                    <mat-icon>check</mat-icon>
                </div>

                <ng-container
                    *ngIf="toggleAndSource.dataSource&&toggleAndSource.dataSource.place==='google'&&toggleAndSource.toggle.placeCategory.thingsToDo">
                    <div item *ngIf="!loadingToggles&&toggleAndSource.toggle.placeCategory.dining"
                         (click)="filterPlace('Dining & Nightlife')" role="button"
                         [class.is-selected]="isSelected('Dining & Nightlife')">
                        Dining & Nightlife
                        <mat-icon>check</mat-icon>
                    </div>
                    <div item *ngIf="!loadingToggles&&toggleAndSource.toggle.placeCategory.shopping"
                         (click)="filterPlace('Shopping')" role="button" [class.is-selected]="isSelected('Shopping')">
                        Shopping
                        <mat-icon>check</mat-icon>
                    </div>

                    <div item *ngIf="isShowThingsToDo" (click)="filterPlace('things-to-do')" role="button" tabindex="0"
                         [class.is-selected]="isSelected('things-to-do')">Things to Do
                        <mat-icon>check</mat-icon>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="(toggleAndSource.dataSource&&toggleAndSource.dataSource.place==='facebook')||!toggleAndSource||!toggleAndSource.toggle.placeCategory.thingsToDo">
                    <div item *ngIf="!loadingToggles&&toggleAndSource.toggle.placeCategory.activity"
                         (click)="filterPlace('Activities')" role="button"
                         [class.is-selected]="isSelected('Activities')">
                        Activities
                        <mat-icon>check</mat-icon>
                    </div>
                    <div item *ngIf="!loadingToggles&&toggleAndSource.toggle.placeCategory.art"
                         (click)="filterPlace('Arts & Culture')" role="button"
                         [class.is-selected]="isSelected('Arts & Culture')">
                        Arts & Culture
                        <mat-icon>check</mat-icon>
                    </div>
                    <div item *ngIf="!loadingToggles&&toggleAndSource.toggle.placeCategory.dining"
                         (click)="filterPlace('Dining & Nightlife')" role="button"
                         [class.is-selected]="isSelected('Dining & Nightlife')">
                        Dining & Nightlife
                        <mat-icon>check</mat-icon>
                    </div>
                    <div item *ngIf="!loadingToggles&&toggleAndSource.toggle.placeCategory.entertainment"
                         (click)="filterPlace('Entertainment')" role="button"
                         [class.is-selected]="isSelected('Entertainment')">
                        Entertainment
                        <mat-icon>check</mat-icon>
                    </div>
                    <div item *ngIf="!loadingToggles&&toggleAndSource.toggle.placeCategory.outdoor"
                         (click)="filterPlace('Outdoors')" role="button" [class.is-selected]="isSelected('Outdoors')">
                        Outdoors
                        <mat-icon>check</mat-icon>
                    </div>
                    <div item *ngIf="!loadingToggles&&toggleAndSource.toggle.placeCategory.wellness"
                         (click)="filterPlace('Wellness')" role="button" [class.is-selected]="isSelected('Wellness')">
                        Wellness
                        <mat-icon>check</mat-icon>
                    </div>

                    <div item *ngIf="!loadingToggles&&toggleAndSource.toggle.placeCategory.shopping"
                         (click)="filterPlace('Shopping')" role="button" [class.is-selected]="isSelected('Shopping')">
                        Shopping
                        <mat-icon>check</mat-icon>
                    </div>
                </ng-container>

                <div item *ngIf="!loadingToggles&&toggleAndSource.toggle.placeCategory.travel"
                     (click)="filterPlace('Transportation')" role="button"
                     [class.is-selected]="isSelected('Transportation')">
                    Travel
                    <mat-icon>check</mat-icon>
                </div>
                <div item *ngIf="!loadingToggles&&toggleAndSource.toggle.placeCategory.other"
                     (click)="filterPlace('Other')" role="button" [class.is-selected]="isSelected('Other')">
                    Other
                    <mat-icon>check</mat-icon>
                </div>
            </ng-container>

            <ng-container *ngIf="toggleAndSource.dataSource&&toggleAndSource.dataSource.businessType==='area business'">
                <div item (click)="filterPlace('Beauty')" role="button" [class.is-selected]="isSelected('Beauty')">
                    Beauty
                    <mat-icon>check</mat-icon>
                </div>
                <div item (click)="filterPlace('Cars & Motor Services')" role="button"
                     [class.is-selected]="isSelected('Cars & Motor Services')">
                    Cars & Motor Services
                    <mat-icon>check</mat-icon>
                </div>

                <div item (click)="filterPlace('Cleaning Services')" role="button"
                     [class.is-selected]="isSelected('Cleaning Services')">
                    Cleaning Services
                    <mat-icon>check</mat-icon>
                </div>
                <div item (click)="filterPlace('Pet Services')" role="button"
                     [class.is-selected]="isSelected('Pet Services')">Pet Services
                    <mat-icon>check</mat-icon>
                </div>
                <div item (click)="filterPlace('Convenience & Pharmacies')" role="button"
                     [class.is-selected]="isSelected('Convenience & Pharmacies')">Convenience & Pharmacies
                    <mat-icon>check</mat-icon>
                </div>
                <div item (click)="filterPlace('Hospitals')" role="button"
                     [class.is-selected]="isSelected('Hospitals')">Hospitals
                    <mat-icon>check</mat-icon>
                </div>
                <!-- <div item (click)="filterPlace('Other Types')" role="button"
                    [class.is-selected]="isSelected('Other Types')">Other Types
                    <mat-icon>check</mat-icon>
                </div> -->
            </ng-container>

            <ng-container *ngIf="!loadingToggles&&toggleAndSource.dataSource.businessType==='local secrets'">
                <div item (click)="filterPlace('Art and Culture')" role="button"
                     [class.is-selected]="isSelected('Art and Culture')">Arts & Culture
                    <mat-icon>check</mat-icon>
                </div>
                <div item (click)="filterPlace('Food and Drink')" role="button"
                     [class.is-selected]="isSelected('Food and Drink')">
                    Food & Drink
                    <mat-icon>check</mat-icon>
                </div>

                <div item (click)="filterPlace('Nightlife')" role="button"
                     [class.is-selected]="isSelected('Nightlife')">
                    Nightlife
                    <mat-icon>check</mat-icon>
                </div>
                <div item (click)="filterPlace('Trip & Tours Planner')" role="button"
                     [class.is-selected]="isSelected('Trip & Tours Planner')">Trip & Tours Planner
                    <mat-icon>check</mat-icon>
                </div>
                <div item (click)="filterPlace('Local Rental Services')" role="button"
                     [class.is-selected]="isSelected('Local Rental Services')">Local Rental Services
                    <mat-icon>check</mat-icon>
                </div>
                <div item (click)="filterPlace('Health & Personal Care')" role="button"
                     [class.is-selected]="isSelected('Health & Personal Care')">Health & Personal Care
                    <mat-icon>check</mat-icon>
                </div>
                <div item (click)="filterPlace('Accommodation')" role="button"
                     [class.is-selected]="isSelected('Accommodation')">Accommodations
                    <mat-icon>check</mat-icon>
                </div>
                <div item (click)="filterPlace('Sports & Leisure')" role="button"
                     [class.is-selected]="isSelected('Sports & Leisure')">Sports & Leisure
                    <mat-icon>check</mat-icon>
                </div>
                <div item (click)="filterPlace('Shoppings')" role="button"
                     [class.is-selected]="isSelected('Shoppings')">Shopping
                    <mat-icon>check</mat-icon>
                </div>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="menuMode==='sidebar'&&customDefaultPlaceCategory&&!customDefaultPlaceCategory.useDefault">
            <div *ngFor="let item of customDefaultPlaceCategory.customCategories"
                 class="custom-default-place-category-wrapper">
                <ig-accordion-editor [item]="item" [isEditMode]="false" [isSelected]="isSelected(item.title)"
                                     (onCategoryClick)="selectCustomDefaultPlaceCategory($event)"></ig-accordion-editor>
            </div>
        </ng-container>

    </ig-accordion>
</ng-container>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component.html